<template>
  <div class="push-login page-background-new">
    <div class="push-login-content">
      <div class="push-login-content-title">欢迎登录</div>
      <van-form @submit="onSubmit" class="push-login-content-form">
        <van-field
          v-model="telphone"
          :rules="[
            {
              required: true,
              pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
              message: '请填写正确的手机号'
            }
          ]"
          type="number"
          placeholder="请输入手机号"
        />
        <van-field
          v-model="verifyCode"
          :rules="[{ required: true, message: '请填写图形验证码' }]"
          placeholder="请输入图形验证码"
        >
          <img
            slot="right-icon"
            :src="verifyCodeImage"
            @click="getVerifyCode"
            alt=""
          />
        </van-field>
        <van-field
          v-model="phoneCode"
          :rules="[{ required: true, message: '请填写短信验证码' }]"
          placeholder="短信验证码"
        >
          <span
            slot="right-icon"
            v-if="verifyCodeImage"
            :style="countDownTime ? 'color: gray;' : 'color: blue'"
            :disabled="countDownTime > 0"
            @click="sendCode"
            class="push-login-content-send-verifycode"
          >
            {{ countDownTime ? `${countDownTime}s后重新发送` : "发送验证码" }}
          </span>
        </van-field>
        <ph-button
          class="push-login-content-commit-button"
          title="立即登录"
          native-type="submit"
        />
      </van-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      telphone: "",
      verifyCode: "",
      phoneCode: "",
      verifyCodeId: "",
      verifyCodeImage: "",
      countDownTime: 0,
      timer: null
    };
  },

  created() {
    this.getVerifyCode();
  },
  methods: {
    getVerifyCode() {
      this.$http.post(this.$api.PUSH_GET_PICCODE, {}).then(res => {
        this.verifyCodeId = res.picId;
        this.verifyCodeImage = res.url;
      });
    },
    sendCode() {
      if (!this.telphone) {
        this.$toast("请输入手机号");
        return;
      }
      if (!this.verifyCode) {
        this.$toast("请输入图形验证码");
        return;
      }
      this.$http
        .post(this.$api.PUSH_GET_PHONECODE, {
          picId: this.verifyCodeId,
          picCode: this.verifyCode,
          telmobile: this.telphone
        })
        .then(() => {
          this.startCountDown();
        });
    },
    onSubmit() {
      this.$http
        .post(this.$api.PUSH_LOGIN, {
          phone: this.telphone,
          smsCode: this.phoneCode
        })
        .then(res => {
          localStorage.setItem("qAccesstoken", res.qAccesstoken);
          this.$toast("登录成功");
          this.$router.push({
            name: "push-list",
            query: {}
          });
        });
    },
    startCountDown() {
      clearInterval(this.timer);
      this.timer = null;
      this.countDownTime = 60;
      this.timer = setInterval(() => {
        if (this.countDownTime > 0) {
          this.countDownTime -= 1;
        } else {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    }
  }
};
</script>

<style lang="less">
.push-login {
  width: 100%;
  height: 100%;
  background-image: url("~@/assets/ic_push_login_bg.png");
  &-content {
    margin-top: 9.2rem;
    padding: 2rem 1rem 1rem 1rem;
    overflow: hidden;
    background-color: white;
    border-radius: 0.67rem 0.67rem 0 0;
    &-send-verifycode {
      font-size: 0.8rem;
      line-height: 1.5rem;
    }

    &-commit-button {
      width: 100%;
      margin: 1rem 0 0 0;
      line-height: 2.5rem;
    }
    &-form {
      padding: 0.8rem;
      background: white;

      .van-cell {
        padding: 0.6rem 0;
        border-bottom: 1px solid @primary-gray;
        input::-webkit-input-placeholder {
          color: gray;
        }
      }

      .van-cell::after {
        position: relative;
      }

      .van-field__body {
        font-size: 0.94rem;
      }
    }
    &-title {
      color: #09f;
      font-weight: 600;
      font-size: 1.3rem;
      text-align: center;
    }
  }
}
</style>
